require('./searchBeneficiaries.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ commons
const { SLASH } = require ('constants/index');
const { getLastNChars, toCamelCase } = require('utilities/stringHelper');

class ContactItemOptions extends React.Component {

    constructor() {
        super();
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
    }

    handleMouseDown (event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        this.props.onFocus(this.props.option, event);
    }

    render () {
        const { option, className } = this.props;
        const contact = option;
        const id = `${contact.id}_Options_${contact.value}`;
        const accountClass = `${className} search-contacts__contact`;
        let optionContent;

        if (contact.value >= 0) {
            const account = (!!contact.iban) ? contact.iban : contact.accountNumber;
            const accountFormatted = getLastNChars(account);
            const fullName = toCamelCase(contact.fullName);
            const alias = contact.alias;

            optionContent = (
                <div id={id} className="search-contacts__contact-description">
                    <span className="search-contacts__contact-description-name">{fullName}</span>
                    <span className="search-contacts__contact-description-separator"> {SLASH} </span>
                    <span className="search-contacts__contact-description-alias">{alias} </span>
                    <span className="search-contacts__contact-description-iban">{accountFormatted}</span>
                </div>
            );
        }

        return (
            <div
                className={accountClass}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
            >
                {optionContent}
            </div>
        );
    }
}

ContactItemOptions.propTypes = {
    className: PropTypes.string,
    onSelect: PropTypes.func,
    onFocus: PropTypes.func,
    option: PropTypes.object,
    isFocused: PropTypes.bool
};

module.exports = ContactItemOptions;